import React from 'react';
import {
  Container,
  Box,
  Typography,
  Button,
  AppBar,
  Toolbar,
  CssBaseline,
  ThemeProvider,
  Grid,
  Card,
  CardContent,
  CardMedia,
} from '@mui/material';
import {theme} from "../theme/theme";
import logo from '../PuerilAlgritmo_Icon.png';
import img01 from '../statics/img/foal-img/fecha_m01_b.png'
import imgstad from '../statics/img/foal-img/carreras_anteriores.png'
import imgagent from '../statics/img/foal-img/Agente.png'
import imggraf from '../statics/img/foal-img/estadistica.png'
import imgUI from '../statics/img/foal-img/carrera.png'
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/Login.context';

const Portal: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline /> {/* Resets CSS for consistent styling */}
      <Box sx={{ background: theme.palette.background.default, minHeight: '100vh' }}>
        {/* Navbar */}
        <AppBar position="static" sx={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }}>
          <Toolbar sx={{ justifyContent: 'space-between', paddingY: { xs: 1, md: 2 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {/* Logo */}
             <img src={logo} width={86} alt='Logo'/>
              <Typography variant="h6" component="div" sx={{ color: theme.palette.common.black, fontWeight: 'bold', fontSize: { xs: '1.2rem', md: '1.5rem' } }}>
                Pueril Algoritmo
              </Typography>
            </Box>
            <Box>
              <Button
                variant="text"
                sx={{
                  color: theme.palette.primary.main,
                  marginRight: 2,
                  '&:hover': {
                    backgroundColor: 'transparent',
                    textDecoration: 'underline',
                  },
                }}
                onClick={() => navigate('/pricing')}
              >
                Precios
              </Button>
              {/* Nuevo botón "Ir a la app" */}
              <Button
                variant="contained"
                sx={{
                  backgroundColor: theme.palette.primary.main,
                  color: theme.palette.common.white,
                  marginRight: 2,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.dark,
                  },
                  fontSize: { xs: '0.8rem', md: '1rem' },
                  padding: { xs: '0.5rem 1rem', md: '0.75rem 1.5rem' }
                }}
                onClick={async () => {
                  await logout();
                  window.location.href = 'https://app.pueril-algoritmo.cl/';
                }}
              >
                Ir a la app
              </Button>
              <Button
                variant="outlined"
                sx={{
                  color: theme.palette.primary.main,
                  borderColor: theme.palette.primary.main,
                  '&:hover': {
                    backgroundColor: theme.palette.primary.light,
                    color: 'white',
                  },
                  fontSize: { xs: '0.8rem', md: '1rem' },
                  padding: { xs: '0.5rem 1rem', md: '0.75rem 1.5rem' }
                }}
                onClick={() => navigate('/login')}
              >
                Iniciar Sesión
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        {/* Hero Section */}
        <Container
          maxWidth="xl"
          sx={{
            textAlign: 'center',
            paddingY: { xs: 8, md: 12 },
            color: 'white',
            background: `url(${img01}) no-repeat center center`,
            backgroundSize: 'cover',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)', // Dark overlay
              zIndex: 1,
            },
          }}
        >
          <Box sx={{ position: 'relative', zIndex: 2 }}>
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontSize: { xs: '2.5rem', sm: '3.5rem', md: '4.5rem', lg: '5.5rem' },
                fontWeight: 'extrabold',
                mb: 3,
                textShadow: '2px 2px 4px rgba(0,0,0,0.7)',
              }}
            >
              Pueril Algoritmo: ¡Tu Potro Inteligente en las Carreras!
            </Typography>
            <Typography
              variant="h5"
              component="p"
              sx={{
                fontSize: { xs: '1rem', md: '1.25rem', lg: '1.5rem' },
                mb: 5,
                maxWidth: '800px',
                mx: 'auto',
                textShadow: '1px 1px 3px rgba(0,0,0,0.7)',
              }}
            >
              Desbloquea el poder de los datos para predecir resultados, analizar caballos y dominar los hipódromos de Chile. Conviértete en un experto con nuestra inteligencia artificial.
            </Typography>
            <Button
              variant="contained"
              sx={{
                backgroundColor: '#f2d40d', // --color-4
                color: theme.palette.text.primary, // Using text.primary for contrast
                padding: '1rem 2.5rem',
                fontSize: { xs: '1rem', md: '1.25rem' },
                fontWeight: 'bold',
                '&:hover': {
                  backgroundColor: '#f67e23', // --color-5 for hover
                  transform: 'translateY(-2px)',
                },
                boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
              }}
              onClick={() => navigate('/register')}
            >
              ¡Regístrate Ahora!
            </Button>
          </Box>
        </Container>

        {/* Features Section */}
        <Container maxWidth="lg" sx={{ paddingY: { xs: 8, md: 10 } }}>
          <Typography
            variant="h3"
            component="h2"
            sx={{
              textAlign: 'center',
              fontWeight: 'bold',
              color: theme.palette.common.white,
              mb: { xs: 6, md: 8 },
              fontSize: { xs: '2rem', md: '3rem' }
            }}
          >
            ¿Qué puedes hacer con Pueril Algoritmo?
          </Typography>
          <Grid container spacing={{ xs: 4, md: 6 }}>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={imgstad}
                  alt="Análisis de Datos"
                  sx={{ borderRadius: '1rem 1rem 0 0', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.src = 'https://placehold.co/600x300/F0F4C3/689F38?text=Imagen+no+disponible'; }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 2 }}>
                    Estadísticas y Historial Completos
                  </Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.1rem' }}>
                    Accede a un vasto historial de resultados de llegadas y datos de carreras. Identifica patrones, tendencias y el rendimiento real de cada caballo para fundamentar.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={imggraf}
                  alt="Predicción Inteligente"
                  sx={{ borderRadius: '1rem 1rem 0 0', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.src = 'https://placehold.co/600x300/E1F5FE/2196F3?text=Imagen+no+disponible'; }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 2 }}>
                    Predicciones con Inteligencia Artificial
                  </Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.1rem' }}>
                    Nuestro algoritmo avanzado procesa miles de datos para ofrecerte predicciones precisas. Conoce el "Handicap", el "Ranking Peso/Velocidad" y visualiza gráficos que te darán una ventaja competitiva única.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={imgagent}
                  alt="Asesoría Experta"
                  sx={{ borderRadius: '1rem 1rem 0 0', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.src = 'https://placehold.co/600x300/FFF3E0/FF9800?text=Imagen+no+disponible'; }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 2 }}>
                    Agente Hípico Personalizada
                  </Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.1rem' }}>
                    Para los más exigentes, nuestro plan Premium incluye acceso a una agente hípico con asesoría personalizada.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={6}>
              <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                <CardMedia
                  component="img"
                  height="250"
                  image={imgUI}
                  alt="Interfaz Intuitiva"
                  sx={{ borderRadius: '1rem 1rem 0 0', objectFit: 'cover' }}
                  onError={(e) => { e.currentTarget.src = 'https://placehold.co/600x300/E8F5E9/4CAF50?text=Imagen+no+disponible'; }}
                />
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h5" component="h3" sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 2 }}>
                    Interfaz Intuitiva y Fácil de Usar
                  </Typography>
                  <Typography variant="body1" sx={{ color: theme.palette.text.secondary, fontSize: '1.1rem' }}>
                    Diseñada pensando en ti, nuestra plataforma es fácil de navegar y te permite acceder a toda la información que necesitas de forma rápida y eficiente, tanto en escritorio como en dispositivos móviles.
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>

        {/* Call to Action Section at the bottom */}
        <Container
          maxWidth="md"
          sx={{
            textAlign: 'center',
            paddingY: { xs: 8, md: 10 },
            mb: 4,
            backgroundColor: '#ffffff',
            borderRadius: '1.5rem',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)',
          }}
        >
          <Typography
            variant="h4"
            component="h2"
            sx={{
              fontWeight: 'bold',
              color: theme.palette.primary.main,
              mb: 3,
              fontSize: { xs: '1.8rem', md: '2.5rem' }
            }}
          >
            ¿Listo para Transformar tus deciciones?
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: theme.palette.text.secondary,
              mb: 5,
              fontSize: { xs: '1rem', md: '1.15rem' }
            }}
          >
            Únete a la comunidad de Pueril Algoritmo y empieza a tomar decisiones basadas en datos. ¡El éxito en el hipódromo te espera!
          </Typography>
          <Button
            variant="contained"
            sx={{
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.common.white,
              padding: '1rem 2.5rem',
              fontSize: { xs: '1rem', md: '1.25rem' },
              fontWeight: 'bold',
              '&:hover': {
                backgroundColor: theme.palette.primary.light,
                transform: 'translateY(-2px)',
              },
              boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
            }}
            onClick={() => alert('Simulando Registro')}
          >
            ¡Regístrate Gratis Ahora!
          </Button>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Portal;